import React from 'react';
import {Icon as LegacyIcon} from '@ant-design/compatible';
import Icon from '@ant-design/icons';
import {checkJsonProp} from './';

export const SmeIcons = {
    // Need () to return and height="1em" and width="1em" for change size
    // And can use any svg
    stepCheck: () => <svg height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" id="aside-check">
      <g data-name="Group 784">
        <path data-name="Path 625" d="M28.5 14.5a14.054 14.054 0 11-6.865-12.023" fill="none" stroke="#7154d6"></path>
        <g data-name="Vector Smart Object">
          <path data-name="Path 74" d="M6.941 11.867l7 6.871 14.556-14.28" fill="none" stroke="#7154d6" stroke-miterlimit="22.926"></path>
        </g>
      </g>
    </svg>,
    stepActive: () => <svg height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="aside-dot">
      <g data-name="Group 785" transform="translate(-555.5 -160)">
        <g data-name="Ellipse 110" transform="translate(555.5 160)" fill="none" stroke="#7154d6">
          <circle cx="14" cy="14" r="14" stroke="none"></circle>
          <circle cx="14" cy="14" r="13.5"></circle>
        </g>
        <circle data-name="Ellipse 118" cx="2.5" cy="2.5" r="2.5" transform="translate(566.458 171.457)" fill="#7154d6"></circle>
      </g>
    </svg>,
    stepInactive: () => <svg height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" id="aside-other">
      <g data-name="Ellipse 107" fill="none" stroke="#b2b2b2">
        <circle cx="9" cy="9" r="9" stroke="none"></circle>
        <circle cx="9" cy="9" r="8.5"></circle>
      </g>
    </svg>,
    loginIcon: () => <svg height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 248.583 161.905" id="identifikavimas">
      <g data-name="Group 631">
        <g data-name="Vector Smart Object" transform="translate(0 2.553)" fill="none" stroke="#000" stroke-miterlimit="22.926">
          <path data-name="Line 40" stroke-width=".931" d="M69.623 56.125H0"></path>
          <path data-name="Line 41" stroke-width=".931" d="M93.533 28.545H54.565"></path>
          <ellipse data-name="Ellipse 24" cx="75.144" cy="75.125" rx="75.144" ry="75.125" transform="translate(81.901 8.636)" stroke-width=".931"></ellipse>
          <ellipse data-name="Ellipse 25" cx="60.979" cy="60.964" rx="60.979" ry="60.964" transform="translate(96.066 22.797)" stroke-width=".931"></ellipse>
          <path data-name="Line 42" stroke-width=".931" d="M139.474 0h35.733"></path>
          <path data-name="Line 43" stroke-width=".93" d="M156.815 44.897V27.844"></path>
          <path data-name="Line 44" stroke-width=".93" d="M156.815 8.911V.525"></path>
          <path data-name="Line 45" stroke-width=".93" d="M156.815 138.934v-17.053"></path>
          <path data-name="Line 46" stroke-width=".931" d="M195.755 83.389h17.058"></path>
          <path data-name="Line 47" stroke-width=".931" d="M101.693 83.389h17.058"></path>
        </g>
        <g data-name="Vector Smart Object">
          <path data-name="Path 74" d="M113.317 46.703l43.838 43L248.261.323" fill="none" stroke="#000" stroke-miterlimit="22.926" stroke-width=".92"></path>
        </g>
      </g>
    </svg>
}

export const CustomIcon = (props) => {
    const {type, icon, style, className, size} = props,
    newStyle = Object.assign(size ? {fontSize: `${size}px`} : {}, {color: 'inherit', ...style});

    switch (type) {
      case 'custom':
        return <Icon className={className} style={newStyle} component={checkJsonProp(SmeIcons, icon)}/>;
      case 'legacy':
        return <LegacyIcon className={className} style={newStyle} type={icon}/>;
      case 'normal':
        return <LegacyIcon className={className} style={newStyle} type={icon}/>;
      default:
        return <LegacyIcon className={className} style={newStyle} type={icon}/>;
    }
}